// Superpone los cambios pendientes del outbox sobre los datos cacheados (o del servidor),
// para que la UI muestre de forma consistente lo creado/editado sin conexión.
import { listOutbox } from "./store";
import { ageFromBirth } from "../calc";

const path = (url) => (url || "").split("?")[0];

function buildPatient(item) {
  const b = item.body || {};
  return {
    ...b,
    patient_id: item.tempId,
    record_number: "EXP-PENDIENTE",
    created_at: item.created_at,
    consultation_count: 0,
    _offline: true,
  };
}

function buildConsultation(item) {
  const b = item.body || {};
  return {
    ...b,
    consultation_id: item.tempId,
    patient_id: item.refPatientId,
    date: b.date || item.created_at,
    created_at: item.created_at,
    status: b.status || "en_progreso",
    _offline: true,
  };
}

function buildPrescription(item) {
  const b = item.body || {};
  return { ...b, prescription_id: item.tempId, created_at: item.created_at, _offline: true };
}

function buildAttachment(item) {
  const f = item.fields || {};
  return {
    attachment_id: item.tempId,
    title: f.title || "Adjunto",
    category: f.category || "otro",
    is_note: !!f.is_note,
    note_text: f.note || "",
    original_filename: f.filename || "",
    created_at: item.created_at,
    _offline: true,
  };
}

export async function applyOverlay(url, data) {
  const p = path(url);
  const ob = await listOutbox();
  if (!ob.length) return data;

  // /patients  (lista)
  if (/^\/patients$/.test(p)) {
    let list = Array.isArray(data) ? [...data] : [];
    const deleted = new Set(ob.filter((o) => o.method === "delete" && /^\/patients\/[^/]+$/.test(path(o.url))).map((o) => path(o.url).split("/")[2]));
    list = list.filter((x) => !deleted.has(x.patient_id));
    // ediciones
    ob.filter((o) => o.method === "put" && /^\/patients\/[^/]+$/.test(path(o.url))).forEach((o) => {
      const id = path(o.url).split("/")[2];
      const i = list.findIndex((x) => x.patient_id === id);
      if (i >= 0) list[i] = { ...list[i], ...(o.body || {}) };
    });
    // creaciones offline
    const consByPat = {};
    ob.filter((o) => o.entity === "consultation" && o.method === "post").forEach((o) => {
      consByPat[o.refPatientId] = (consByPat[o.refPatientId] || 0) + 1;
    });
    ob.filter((o) => o.entity === "patient" && o.method === "post").forEach((o) => {
      const pt = buildPatient(o);
      pt.consultation_count = consByPat[o.tempId] || 0;
      list.unshift(pt);
    });
    return list;
  }

  // /patients/{id}
  let m = p.match(/^\/patients\/([^/]+)$/);
  if (m) {
    const id = m[1];
    let obj = data;
    const created = ob.find((o) => o.entity === "patient" && o.method === "post" && o.tempId === id);
    if (created) obj = buildPatient(created);
    ob.filter((o) => o.method === "put" && path(o.url) === `/patients/${id}`).forEach((o) => {
      obj = { ...(obj || {}), ...(o.body || {}) };
    });
    if (obj && !obj.age && obj.birth_date) {
      const a = ageFromBirth(obj.birth_date);
      obj.age = { years: a.years, months: a.months, text: a.text };
    }
    return obj;
  }

  // /patients/{id}/consultations
  m = p.match(/^\/patients\/([^/]+)\/consultations$/);
  if (m) {
    const pid = m[1];
    let list = Array.isArray(data) ? [...data] : [];
    // ediciones de consultas
    const updates = {};
    ob.filter((o) => o.method === "put" && /^\/consultations\/[^/]+$/.test(path(o.url))).forEach((o) => {
      const cid = path(o.url).split("/")[2];
      updates[cid] = { ...(updates[cid] || {}), ...(o.body || {}) };
    });
    list = list.map((c) => (updates[c.consultation_id] ? { ...c, ...updates[c.consultation_id] } : c));
    // creaciones offline para este paciente
    ob.filter((o) => o.entity === "consultation" && o.method === "post" && o.refPatientId === pid).forEach((o) => {
      const c = buildConsultation(o);
      if (updates[o.tempId]) Object.assign(c, updates[o.tempId]);
      list.push(c);
    });
    return list;
  }

  // /patients/{id}/prescriptions
  m = p.match(/^\/patients\/([^/]+)\/prescriptions$/);
  if (m) {
    const pid = m[1];
    let list = Array.isArray(data) ? [...data] : [];
    ob.filter((o) => o.entity === "prescription" && o.method === "post" && o.refPatientId === pid).forEach((o) => list.push(buildPrescription(o)));
    return list;
  }

  // /patients/{id}/attachments
  m = p.match(/^\/patients\/([^/]+)\/attachments$/);
  if (m) {
    const pid = m[1];
    let list = Array.isArray(data) ? [...data] : [];
    ob.filter((o) => o.entity === "attachment" && o.method === "post" && o.refPatientId === pid).forEach((o) => list.push(buildAttachment(o)));
    return list;
  }

  return data;
}
